<template>
  <div class="modal fade uploadModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content col-6" style="margin: 0 auto;">
        <div class="modal-body upload-body">
          <div class="upload-full">
            <div class="float-left upload-lf">Fotos importieren</div>
            <div class="float-right">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="clearstack()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div class="uploadOuter" v-if="showdragndrop">
            <!--  <label for="uploadFile" class="btn btn-primary">Upload Image</label>
               <strong>OR</strong> -->
            <span class="dragBox" >
                      <div class="drag-t">Drag and Drop</div>
                      <span class="drag-h">Ziehen Sie Ihre Fotos in diesen Bereich</span>
                      <button type="button" class="btn btn-light mode-uploadbtn">Fotos auswählen</button>
                          <input type="file" class="d-input" accept="image/*"
                                 @change="dragNdrop" id="uploadFile" multiple="multiple" />
                   </span>
          </div>
          <span class="upload-status">Upload Status</span><span class="state-num">{{totalprogress}}%</span>
          <div class="progress progbar-st">
            <div class="progress-bar custom-bar" role="progressbar" :style="{width:totalprogress+'%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          <div id="preview" class="d-flex align-content-start flex-wrap flex4grid">




<!--            <template v-for="(item, index) in uploadstack">-->
            <template v-for="(item,index) in uploadstack"  v-model="uploadstack[index]">
              <div class="pimg-box"  style="height:auto; padding-bottom:0.5rem" v-bind:class="[item.quality, item.md5hash, item.missingexifdata ? 'orangeborder' : '']" v-bind:id="'item_' + item.md5hash">
                <span class="fa fa-remove removeitem" @click="removeUploadItem(item.md5hash)"></span>
                <div class="float-right" data-aspect-ratio="1:1" style="width:50%">
                  <img v-if="item.thumb" :src="item.thumb">
                  <img v-if="!item.thumb" src="@/assets/images/dumy.jpg">
                </div>
                <img :src="item.icon">

                <div style="width:100%; display: block;">
                  <span class="i-span" style="width:100%; display: block;">{{item.name}}</span>
                  <br/>
                  <span class="i-span" style="width:100%; display: block;"><br />{{item.exifdate | toDEDate()}}</span>
                  <!--                <span v-if="!item.missingexifdata" class="i-span"><br />{{item.exifdate | toDEDate()}}</span>-->
                  <br/>
                </div>
                <div style="width:100%; display:flex; position: relative">
                  <div class="datepickerwrapper" v-if="item.missingexifdata" style="min-height: 30px;">
                    <date-picker
                      v-model="item.exifdate"
                      :keepOpen="false"
                      @dp-hide="changeDateOfImage($event, item.exifdate, item.md5hash)"
                      :config="datepickeroptions"
                      :id="'datepicker_'+ item.md5hash"
                      class="pddatetimepicker  form-control input-groupccc "
                      style="margin-left: 4px; border: 0; padding: 0; width: 0;margin-bottom: -8px"></date-picker>
                    <label :for="'datepicker_'+ item.md5hash" style="top: 50% !important;">
                      <div class="font12 p-1 rounded border ml-1 shadow-sm">
                        <span class="pl-2 fa fa-calendar" style="font-size: 18px; color: #ccc"></span>
                        <span class="pl-1 pr-1">Datum auswahlen </span>
                      </div>
                    </label>
                  </div>
                </div>




                <div class="progress sm-custombar">
                  <div :id="'item_'+item.id" class="progress-bar smbar-color" role="progressbar" style="width:0" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <span class="image_exists">Bild existiert bereits.</span>
              </div>

            </template>


          </div>

          <div class="row px-1 pt-2" v-if="missingexifdata">
            <div class="col-sm-6">
              <date-picker v-model="globaldate"
                           @dp-hide="setGlobalExifDate($event)"
                           :config="datepickeroptions"
                           class="pddatetimepicker"
              ></date-picker>
            </div>
            <div class="col-sm-6 text-center">
              <span class="i-span w-100">Datum für alle Bilder ohne EXIF Daten hier angeben.<br />
                (Achtung, bereits getätigte Änderungen werden überschrieben)</span>

            </div>
          </div>


          <div class="row pt-2"  v-if="allowupload && uploadstack.length > 0 && !closeBtn">
            <div class="col-sm-12 text-center pt-2">
              <button @click="startupload" class="active btn btn-light">Upload starten</button>
            </div>
          </div>
          <div class="row pt-3" v-show="closeBtn">
            <div class="col-sm-12 text-center pt-3">
              <button class="active btn btn-primary" type="button" data-dismiss="modal" aria-label="Close" @click="clearstack()">
                Fertig
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from 'js-md5'
import axios from 'axios'
import EXIF from 'exif-js'
import moment from 'moment'
import exifr from 'exifr'
// import datePicker from 'vue-bootstrap-datetimepicker';
export default {

  name: 'photo-modal',
  data () {
    return {
      error: [],
      msg: [],
      uploadPercentage: 0,
      totalprogress: 0,
      images_ready: false,
      closeBtn: false,
      uploadstack: [],
      allowupload: false,
      filestoupload: 0,
      currentFile: {
        formData: [],
        file: null
      },
      showdragndrop: true,
      datepickeroptions: {
        extraFormats: ['YYYY-MM-DD HH:mm:ss','DD.MM.YYYY HH:mm:ss'],
        format: 'DD.MM.YYYY HH:mm',
        useCurrent: true,
        locale: "de",
        sideBySide: true,
        calendarWeeks: true,
        showTodayButton: true,
        keepOpen: false,
        stepping: 15,
        showClear: true,
        showClose: true,
        allowInputToggle: true
      },
      testdate: new Date(),
      missingexifdata: false,
      globaldate: new Date(),
      localtoast: null

    }
  },
  components: {
    // datePicker
  },
  filters: {
    toDEDate: function(string) {
      return moment(string).format('DD.MM.YYYY HH:mm:ss')
    }
  },
  mounted () {
    let dt = new Date()
    this.globaldate = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 0, 0, 0)
  },
  methods: {
    changeDateOfImage (e, other, md5hash) {

      // get the index by md5hash
      let index = this.uploadstack.findIndex((e) => e.md5hash == md5hash)

      console.log('DateChangeOf Image', e, e.date, other, this.uploadstack[index])


      console.log('DateChangeOf Image Formated', e, e.date.format('YYYY-MM-DD HH:mm'))
      $(this).val(e.date.format('YYYY-MM-DD HH:mm') + ':00')
      other = e.date.format('YYYY-MM-DD HH:mm') + ':00'

      this.uploadstack[index].exifdate = other
      this.stackupdate()


    },
    setGlobalExifDate (e) {
      let targetdate = e.date.format('YYYY-MM-DD HH:mm')

      this.uploadstack.forEach(function(val, idx) {
        if(val.missingexifdata) {
          val.exifdate = targetdate
        }
      })

      this.stackupdate()

    },
    drag () {

    },
    drop () {

    },
    async checkfileExit (file, filearray) {
      let today = new Date()
      let date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()

      // https://stackoverflow.com/questions/14733374/how-to-generate-an-md5-file-hash-in-javascript
      var params =
        {
          'methodName': 'getPhotoQualities',
          'parameters': [
            this.$route.params.id,
            [
              md5(file)
            ]
          ],
          'serviceName': 'ProjectdocuService'
          // 'hash': md5(file),
          // 'filetype': 'photo',
          // 'photodate': date
        }
      await axios
        .post(
          process.env.VUE_APP_BASE_AMF_URL + 'addfile_fileexists/&token=' + localStorage.sessiontoken,
          params,
          {
            headers: {
              apitoken: localStorage.apikey,
              deviceid: localStorage.deviceid,
              accept: 'application/json'
            }
          }
        )
        .then(response => {

          filearray.quality = response.data.versions[md5(file)].quality

          console.log('FileCheck', response.data, response.data.versions[md5(file)].pdphotoid)

          if(filearray.quality == 'missing') {
            jQuery("."+md5(file)).addClass('missing')
          }

          return response.data.versions[md5(file)].pdphotoid
        })
        .catch(e => {
          this.error.push(e)
        })
    },

    // uploadFile (file, formData, progressID) {
    uploadFile (filestack, idx = 0) {
      let _this = this
      const thisfile = filestack[idx]
      console.log('ThisFile', filestack, thisfile)
      let progressID = thisfile.id
      let filemd5hash = thisfile.md5hash

      this.getFormDataForFile(thisfile)

      $('.spinner-cover').show()

      let reader = new FileReader()
      reader.addEventListener('load', function () {
        _this.currentFile.formData.append('hash', md5(reader.result))
        _this.currentFile.file = reader.result
        // await axios.post(process.env.VUE_APP_BASE_AMF_URL + `getProject&token=` + localStorage.sessiontoken, {
        axios.post(process.env.VUE_APP_BASE_URL + 'backend/put?PHPSESSID=' + localStorage.sessiontoken + '&method=img&projectid=' + _this.$route.params.id + '&type=addfile_photo&token=' + localStorage.sessiontoken,
          _this.currentFile.formData,
          {
            headers: {
              apitoken: localStorage.apikey,
              deviceid: localStorage.deviceid,
              accept: 'application/json'
            },
            onUploadProgress: function (progressEvent) {
              let currentfilepercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100)) + '%'
              _this.uploadPercentage = (parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100)) / _this.filestoupload) + '%'
              _this.totalprogress += Math.floor( 100 / filestack.length )
              if(_this.totalprogress >= 99) {
                _this.totalprogress = 100;
                _this.closeBtn = true;
                 const val = _this.$parent.photosUpdate;
                 setTimeout(function (){
                   _this.$parent.photosUpdate = val === 'update' ? 'refresh' : 'update';
                 },1000)
              }
              $('#item_' + filemd5hash + ' .progress-bar').css('width', currentfilepercentage)
            }
          }
        ).then(response => {
          $('.spinner-cover').hide()
          // $('#item_' + progressID).css('background-color', '#2AC940')
          $('#item_' + filemd5hash).css('border-color', '#2AC940')
          if (filestack[idx+1]){
            _this.uploadFile(filestack, idx+1);
          }
          if (response > 0) {
            // this.msg.push(response.data.status)
            this.msg.push('Datei erfolgreich hochgeladen')
          }
        }).catch(e => {
          $('.spinner-cover').hide()
          $('#' + progressID).css('background-color', '#FF5Fwq58')
          _this.error.push(e)
        })

        // let res = _this.uploadFile(reader.result, formData, idx)
      }, false)

      reader.readAsDataURL(thisfile)
    },










    readImage (file) {
      var reader = new FileReader()
      var image = new Image()
      var formData = new FormData()
      let today = new Date()
      let date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
      let lastModified = new Date(file.lastModified)

      let currentMonth = ('0' + (lastModified.getMonth() + 1)).slice(-2)
      let currentDay = ('0' + lastModified.getDate()).slice(-2)
      let currentHours = ('0' + lastModified.getHours()).slice(-2)
      let currentMinutes = ('0' + lastModified.getMinutes()).slice(-2)
      let currentSeconds = ('0' + lastModified.getSeconds()).slice(-2)

      let filedate = lastModified.getFullYear() + '-' + currentMonth + '-' + currentDay + ' ' + currentHours + ':' + currentMinutes + ':' + currentSeconds

      formData.append('quality', 'original')
      formData.append('Filedata', file)
      formData.append('Filename', file.name)
      formData.append('photodate', filedate)
      formData.append('exifgpsx', '0')
      formData.append('exifhasgps', '0')
      formData.append('exifgpsy', '0')
      formData.append('exifwidth', '')
      formData.append('exifheight', '')
      formData.append('exifdate', filedate)
      formData.append('Upload', 'Start')

      let _this = this

      image.onload = function() {
        console.log("Image specs are " + image.width + "px")
        // Get file params
        image.src = reader.result
        console.log('Reader Res ', image)

        console.log('IMG Width', image.width)
        console.log('IMG Height', image.height)


        formData.append('exifwidth', image.width)
        formData.append('exifheight', image.height)
      }
      reader.readAsDataURL(file)

      var id = Math.floor(Math.random() * 99999999)
      reader.addEventListener('load', function () {
        formData.append('hash', md5(reader.result))

        _this.uploadFile(reader.result, formData, id)
      }, false)
      reader.onload = function (_file) {
        var w = this.width,
          h = this.height,
          t = file.type,
          n = file.name,
          s = ~~(file.size / 1024) + 'KB'

      }
    },

    async startupload() {
      this.totalprogress = 0;
      this.showdragndrop = false;

      let _this = this
      this.uploadstack.sort(this.SortfilesByDate)

      let filestoload = 0
      this.uploadstack.forEach(function(file, idx) {
        if(file.quality == 'missing') {
          filestoload++
        }
      });
      _this.filestoupload = filestoload


      var filestack = []

      this.uploadstack.forEach(function(file, idx) {
        if(file.quality == 'missing') {
          filestack.push(file)
        }
      })
      await this.uploadFile(filestack)
      _this.$store.state.photo.refreshlist = true
    },


    getFormDataForFile(file) {

      console.log('GetFormDataForFile', file)
      var formData = new FormData()
      // let lastModified = new Date(file.lastModified)
      // let filedate = moment(lastModified).format('YYYY-MM-DD HH:mm:ss')
      // let exifdate = filedate
      // if(file.exifdata && file.exifdata.DateTimeOriginal != undefined) {
      //   exifdate = filedate = moment(file.exifdata.DateTimeOriginal, 'YYYY:MM:DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
      // }
      let filedate = file.exifdate


      formData.append('quality', 'original')
      formData.append('Filedata', file)
      formData.append('Filename', file.name)
      formData.append('photodate', filedate)
      if(file.exifdata !== undefined && file.exifdata.GPSLatitude !== undefined) {
        formData.append('exifhasgps', '1')
        formData.append('exifgpsx', file.exifdata.longitude)
        formData.append('exifgpsy', file.exifdata.latitude)
      } else {
        formData.append('exifgpsx', '0')
        formData.append('exifhasgps', '0')
        formData.append('exifgpsy', '0')
      }

      if(file.exifdata !== undefined && file.exifdata.GPSImgDirection != undefined) {
        formData.append('exifhasgpsdirection', 1)
        formData.append('exifgpsdirection', Math.round(file.exifdata.GPSImgDirection))
      }

      if(file.exifdata !== undefined) {
        formData.append('exifwidth', file.exifdata.ExifImageWidth)
        formData.append('exifheight', file.exifdata.ExifImageHeight)
        formData.append('exifdate', file.exifdate)
        formData.append('exif', file.exifdata)
      } else {

        formData.append('exifwidth', '')
        formData.append('exifheight', '')
        formData.append('exifdate', '')
        formData.append('exif', '')
      }
      formData.append('Upload', 'Start')

      this.currentFile.formData = formData
    },

    getFileRead(file) {
      let _this = this

      let reader = new FileReader()
      reader.addEventListener('load', function () {
        _this.currentFile.formData.append('hash', md5(reader.result))
        _this.currentFile.file = reader.result
        // let res = _this.uploadFile(reader.result, formData, idx)
      }, false)

      reader.readAsDataURL(file)
    },



    async dragNdrop (e) {

      // this.uploadstack = []
      let _this = this
      let F = $('#uploadFile').prop('files')
      console.log('FileDrop (dragNdrop function)',F)
      F = Array.from(F)
      let new_list = []
      if (F && F[0]) {

        console.log('File Stack F', F)
        F.forEach(function(val, idx) {

          val.exifdate = 'empty'
          val.quality = ''

          // Neu
          /*
          Wenn Datum vorhanden in EXIF - dann dieses nehmen
          Wenn nicht vorhanden, prüfen ob im Dateinamen ein Valides Datum vorhanden ist
          Wenn nicht das FileCreate Date von Festplatte nehmen
          Wenn nicht kein Datum vorhanden, dann aktuelles Datum nutzen
           */

          _this.getExifData(val).then((result) => {
            val.exifdata = result
            // val.exifdate = result.DateTimeOriginal
            console.log('Exifdata: Value Data', val, result)

            console.log('Exifdata: TypeOf Result', result, typeof result)

            val.missingexifdata = false
            if (typeof result === 'object' && result.DateTimeOriginal !== undefined && (moment(result.DateTimeOriginal, "YYYY:MM:DD HH:mm:ss", true)).isValid()){
              val.exifdate = moment(result.DateTimeOriginal, "YYYY:MM:DD HH:mm:ss").format('YYYY-MM-DD HH:mm:ss')
            } else if (typeof result === 'object' && result.DateTimeOriginal !== undefined && (moment(result.DateTimeOriginal, "YYYY-MM-DD HH:mm:ss", true)).isValid()){
              val.exifdate = moment(result.DateTimeOriginal, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD HH:mm:ss')
            } else {
              val.exifdate = moment(val.lastModified, 'unix').format('YYYY-MM-DD HH:mm:ss')
              val.missingexifdata = true
              _this.missingexifdata = true

              if($('.info_exifdate_toast').length <= 0) {
                _this.localtoast = _this.$toast(
                  'Bild ohne Exifdaten. Es wird das letzte bekannte Dateidatum benutzt, alternativ ändern Sie es je Bild oder Global.',
                  {
                    timeout: false,
                    closeOnClick: true,
                    toastClassName: "info_exifdate_toast",
                  }
                )
              }
            }


            // if (val.exifdate !== undefined && (moment(val.exifdate)).isValid() ) {
            //   val.exifdate = moment(val.exifdate).format('YYYY-MM-DD HH:mm:ss')
            // } else if (val.lastModified !== undefined && (moment(val.lastModified, 'unix')).isValid()) {
            //   val.exifdate = moment(val.lastModified, 'unix').format('YYYY-MM-DD HH:mm:ss')
            // } else {
            //   val.exifdate = moment(val.lastModified, 'unix').format('YYYY-MM-DD HH:mm:ss')
            // }

            _this.$forceUpdate()
            _this.stackupdate()

            console.log('FILEUP - EXIFPARAMS', val.exifdata)
          })

          console.log('EXIFR DATA', exifr)
          val.thumb = exifr.thumbnailUrl(val).then((res) => {
            console.log('ExifR Thumb Url', res)
            _this.stackupdate()
          })

          if(val.thumb == undefined) {
            val.thumb = process.env.VUE_APP_BASE_URL + 'assets/images/dumy.jpg'
            _this.stackupdate()
          }

          // val.thumbsrc = exifr.thumbnail(val).then((res) => {
          //   console.log('ExifR Thumb SRC', res)
          //
          // })

          val.n = val.name
          val.id = idx
          val.ext = val.n.split('.').pop().toLowerCase()

          if ((val.ext == 'jpg') || (val.ext == 'jpeg')) {
            val.icon = require('@/assets/images/img-icons/jpg.png')
          }
          if ((val.ext == 'png')) {
            val.icon = require('@/assets/images/img-icons/png.png')
          }
          if ((val.ext == 'gif')) {
            val.icon = require('@/assets/images/img-icons/gif.png')
          }
          if ((val.ext == 'doc')) {
            val.icon = require('@/assets/images/img-icons/doc.png')
          }
          if ((val.ext == 'xlsx')) {
            val.icon = require('@/assets/images/img-icons/xlsx.png')
          }
          if ((val.ext == 'docx')) {
            val.icon = require('@/assets/images/img-icons/docx.png')
          }
          if ((val.ext == 'pdf')) {
            val.icon = require('@/assets/images/img-icons/pdf.png')
          }


          var reader = new FileReader()

          reader.addEventListener('load', function () {
            val.md5hash = md5(reader.result)
            _this.checkfileExit(reader.result, val)
            _this.$forceUpdate()
          }, false)

          reader.readAsDataURL(val)



          _this.uploadstack.push(val)

        })


      }


      console.log('Stack on dragNDrop', _this.uploadstack)
      // _this.uploadstack.forEach(function(val, idx) {
      //   _this.appendPreview(idx, val)
      // })


      // this.$store.state.photo.refreshlist = true
    },

    async getExifData(file) {
      let vars;
      await exifr.parse(file, {reviveValues: false})
        .then( response => {
          vars = response
        })


      file.thumb = await exifr.thumbnailUrl(file)
      return vars
    },

    appendPreview(idx, file) {

      let n = file.name
      let id = idx //Math.floor(Math.random() * 99999999)
      let ext = n.split('.').pop().toLowerCase()

      console.log('File Append', idx, n, ext, file)

      let src = require('@/assets/images/img-icons/jpg.png')
      if ((ext == 'jpg') || (ext == 'jpeg')) {}
      if ((ext == 'png')) {
        let src = require('@/assets/images/img-icons/png.png')
      }
      if ((ext == 'gif')) {
        let src = require('@/assets/images/img-icons/gif.png')
      }
      if ((ext == 'doc')) {
        let src = require('@/assets/images/img-icons/doc.png')
      }
      if ((ext == 'xlsx')) {
        let src = require('@/assets/images/img-icons/xlsx.png')
      }

      if ((ext == 'docx')) {
        let src = require('@/assets/images/img-icons/docx.png')
      }

      if ((ext == 'pdf')) {
        let src = require('@/assets/images/img-icons/pdf.png')
      }
      $('#preview').append('<div class="pimg-box"><img src="' + src + '"><span class="i-span">' + n + '</span><br/>' +
        '<div class="progress sm-custombar">' +
        '<div class="progress-bar smbar-color" role="progressbar"  id="' + id + '"  style="width:20%" aria-valuenow="20" aria-valuemin="0"' +
        'aria-valuemax="100"></div>' +
        '</div>' +
        '</div>')
    },


    SortfilesByDate (a, b) {

      if(a.exifdate < b.exifdate) {
        console.log('InSort', a + ' lower ' + b)
        return -1
      }
      if(a.exifdate > b.exifdate) {
        console.log('InSort', a + ' Bigger ' + b)
        return 1
      }
      console.log('InSort', a + ' EQUAL ' + b)
      return 0
    },

    getIndex(list, id) {
      return list.findIndex((e) => e.id == id)
    },

    stackupdate(spliceit = true) {
      console.log('StackCahnged', this.uploadstack)
      let allowupload = true
      if(spliceit) {
        this.uploadstack.splice(0,0)
      }
      this.uploadstack.forEach(function(val, idx) {
        console.log('StackCahnged', val.exifdate)
        if(val.exifdate == '') {
          allowupload = false
        }
      })
      this.allowupload = true
    },

    removeUploadItem(md5hash) {
      let index = this.uploadstack.findIndex((e) => e.md5hash == md5hash)
      console.log('Remove Item', index, this.uploadstack)
      this.uploadstack.splice(index, 1)
      console.log('Stack', this.uploadstack)
    },

    clearstack() {
      this.closeBtn = false;
      this.uploadstack = []
      this.showdragndrop = true
      this.totalprogress = 0
      this.uploadPercentage = 0
      this.$store.state.photo.refreshlist = true
      return true
    }
  },
  watch: {
    uploadstack() {
      this.stackupdate(false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/photo/components/PhotoModal.vue